import Nullstack from 'nullstack';
export default function IconDownloadOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-download-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 1.83 -1.19"
  }), "   ", Nullstack.element("path", {
    d: "M7 11l5 5l2.005 -2.005m1.994 -1.994l1.001 -1.001"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v4m0 4v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}